import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const HideChartIcon = forwardRef<SVGSVGElement, IconProps>(function HideChartIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icon/18px/Outline/Chart-hide" clipPath="url(#clip0_1234_109)">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2526 2.32892C14.0524 1.3124 12.0988 1 9 1C2.412 1 1 2.412 1 9C1 12.0988 1.3124 14.0524 2.32892 15.2526L3.23556 14.3459C2.98993 13.9828 2.78433 13.4923 2.6328 12.8105C2.42173 11.8607 2.33333 10.6244 2.33333 9C2.33333 7.37556 2.42173 6.13926 2.6328 5.18952C2.84278 4.24471 3.15658 3.6673 3.53681 3.28707C4.2782 2.54568 5.68069 2.15629 9 2.15629C12.1944 2.15629 13.6135 2.51693 14.3766 3.20487L15.2526 2.32892ZM11.6667 8.75184L12.611 7.80755C12.8405 7.89887 13 8.09995 13 8.33333V12.3333C13 12.6526 12.7015 12.9115 12.3333 12.9115C11.9651 12.9115 11.6667 12.6526 11.6667 12.3333V8.75184ZM9.66667 7.91482V5.66667C9.66667 5.34736 9.36819 5.08852 9 5.08852C8.63181 5.08852 8.33333 5.34736 8.33333 5.66667V9.24816L9.66667 7.91482ZM8.33333 12.0852L9.66667 10.7518V12.3333C9.66667 12.6526 9.36819 12.9115 9 12.9115C8.63181 12.9115 8.33333 12.6526 8.33333 12.3333V12.0852ZM4.95012 15.4684C5.82948 15.7163 7.10107 15.8437 9 15.8437C12.3193 15.8437 13.7218 15.4543 14.4632 14.7129C14.8434 14.3327 15.1572 13.7553 15.3672 12.8105C15.5783 11.8607 15.6667 10.6244 15.6667 9C15.6667 7.37556 15.5783 6.13926 15.3672 5.18952C15.3587 5.15148 15.3501 5.11403 15.3413 5.07718L16.3984 4.02014C16.8451 5.20334 17 6.81769 17 9C17 15.588 15.588 17 9 17C6.81769 17 5.20334 16.8451 4.02014 16.3984L4.95012 15.4684ZM6.33333 11.2482V9.66667C6.33333 9.34736 6.03486 9.08852 5.66667 9.08852C5.29848 9.08852 5 9.34736 5 9.66667V12.3333C5 12.4055 5.01526 12.4746 5.04313 12.5384L6.33333 11.2482Z"
            fill={color || 'currentColor'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8098 0.19023C18.0634 0.443869 18.0634 0.8551 17.8098 1.10874L1.10874 17.8098C0.8551 18.0634 0.443869 18.0634 0.19023 17.8098C-0.0634099 17.5561 -0.0634099 17.1449 0.19023 16.8913L16.8913 0.19023C17.1449 -0.0634099 17.5561 -0.0634099 17.8098 0.19023Z"
            fill="#534D65"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1234_109">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});
